import {FC, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import {Input} from '../../../../components/Input/Input'
import {i18n} from '../../../../translate/i18n'
import {AdditionalListType} from '../../../../context/additionalContext'
import useAdditional from '../../../../hooks/useAdditional'
import Swal from 'sweetalert2'
import {GET, POST} from '../../../../services/api'
import {Loading} from '../../../../components/Loading/Loading'
import ReactLoading from 'react-loading'

type ClassificationType = {
  id: string
  code: string
  name: string
}

type ProductType = {
  id: string
  code: string
  name: string
  type: string
  classification: ClassificationType
  sellAsFractional: boolean
}

type ProductSimpleType = {
  id: string
  code: string
  name: string
  checked: boolean
}

type ClassificationWithProductsType = {
  id: string
  code: string
  name: string
  products: ProductSimpleType[]
  extend: boolean
}

const AssociarOpcionaisContent: FC = () => {
  const params = useParams()
  const {id} = params
  const navigate = useNavigate()
  const {getAdditionalIdAssociatePage} = useAdditional()
  const [additional, setAdditional] = useState<AdditionalListType>()
  const [classificationWithProducts, setClassificationWithProducts] = useState<
    ClassificationWithProductsType[]
  >([])
  const [classificationWithProductsAll, setClassificationWithProductsAll] = useState<
    ClassificationWithProductsType[]
  >([])
  const [loading, setLoading] = useState(false)
  const [query, setQuery] = useState('')
  const [searchLoading, setSearchLoading] = useState<string[]>([])

  const callAdditionals = async () => {
    const responseAdditionals = await getAdditionalIdAssociatePage(id ? parseInt(id) : 0)
    if (responseAdditionals.success && responseAdditionals.data && responseAdditionals.data[0]) {
      await getProducts(responseAdditionals.data[0])
      setAdditional(responseAdditionals.data[0])
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: responseAdditionals.data ? responseAdditionals.data : 'Erro ao obter adicional',
      })
    }
  }

  const isCheckedProduct = (product: ProductType, add: AdditionalListType) => {
    const productFinded = add.products.find(
      (pd) => parseInt(pd.product.id.toString()) === parseInt(product.id)
    )
    return productFinded ? true : false
  }

  const formatClassificationsWithProducts = async (
    products: ProductType[],
    add: AdditionalListType
  ) => {
    const classifications: ClassificationWithProductsType[] = []
    const classificationIds: string[] = []
    products.forEach((product) => {
      if (product.classification) {
        if (!classificationIds.includes(product.classification.id)) {
          classifications.push({
            id: product.classification.id,
            code: product.classification.code,
            name: product.classification.name,
            extend: true,
            products: [
              {
                id: product.id,
                code: product.code,
                name: product.name,
                checked: isCheckedProduct(product, add),
              },
            ],
          })
          classificationIds.push(product.classification.id)
        } else {
          classifications.forEach((category) => {
            if (category.id === product.classification.id) {
              category.products.push({
                id: product.id,
                code: product.code,
                name: product.name,
                checked: isCheckedProduct(product, add),
              })
            }
          })
        }
      }
    })
    setClassificationWithProductsAll(classifications)
    setClassificationWithProducts(classifications)
  }

  const getProducts = async (add: AdditionalListType) => {
    try {
      const productRes = await GET('product/optionals/association-optional')
      if (productRes && productRes.success && productRes.data) {
        const products: ProductType[] = productRes.data
        formatClassificationsWithProducts(
          products.filter((pd) => pd.type !== 'optional'),
          add
        )
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao obter produtos',
        })
      }
    } catch (e: any) {
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e && typeof e === 'string' ? e : 'Erro ao obter produtos',
      })
    }
  }

  const verifyChecks = (classification: ClassificationWithProductsType) => {
    let allChecked = true
    classification.products.forEach((pd) => {
      if (!pd.checked) allChecked = false
    })
    return allChecked
  }

  const checkAll = (classification: ClassificationWithProductsType) => {
    setLoading(true)
    const newClassifications = [...classificationWithProducts]
    newClassifications.forEach((cl) => {
      if (cl.id === classification.id) {
        const allChecks = verifyChecks(classification)
        cl.products.forEach((pd) => {
          pd.checked = allChecks === false
        })
      }
    })
    setClassificationWithProducts(newClassifications)

    const newClassificationsAll = [...classificationWithProductsAll]
    newClassificationsAll.forEach((cl) => {
      cl.products.forEach((pd) => {
        newClassifications.forEach((clN) => {
          clN.products.forEach((pdN) => {
            if (pd.id === pdN.id) {
              pd.checked = pdN.checked
            }
          })
        })
      })
    })
    setClassificationWithProductsAll(newClassificationsAll)
    setTimeout(() => {
      setLoading(false)
    }, 200)
  }

  const changeExtend = (classification: ClassificationWithProductsType) => {
    const newClassifications = [...classificationWithProducts]
    newClassifications.forEach((cl) => {
      if (cl.id === classification.id) {
        cl.extend = !cl.extend
      }
    })
    setClassificationWithProducts(newClassifications)

    const newClassificationsAll = [...classificationWithProductsAll]
    newClassificationsAll.forEach((cl) => {
      if (cl.id === classification.id) {
        cl.extend = !cl.extend
      }
    })
    setClassificationWithProductsAll(newClassificationsAll)
  }

  const filterWordsProducts = () => {
    const classificationsBackup = [...classificationWithProductsAll]
    const classifications = [...classificationWithProducts]
    const newClassifications: ClassificationWithProductsType[] = []

    classificationsBackup.forEach((cl) => {
      cl.products.forEach((pd) => {
        classifications.forEach((clN) => {
          clN.products.forEach((pdN) => {
            if (pd.id === pdN.id) {
              pd.checked = pdN.checked
            }
          })
        })
      })
    })
    classificationsBackup.forEach((cl) => {
      const filterProducts = cl.products.filter((pd) =>
        pd.name.toLocaleLowerCase().includes(query.toLocaleLowerCase())
      )
      newClassifications.push({
        id: cl.id,
        name: cl.name,
        code: cl.code,
        extend: cl.extend,
        products: filterProducts,
      })
    })
    setClassificationWithProducts(newClassifications)
  }

  const saveAdditionals = async () => {
    try {
      setLoading(true)
      let productIds: string[] = []
      classificationWithProductsAll.forEach((cl) => {
        cl.products.forEach((pd) => {
          if (pd.checked) {
            productIds.push(pd.id)
          }
        })
      })
      const additionalRes = await POST('optional/father', {
        optionalId: id,
        productIds: productIds,
      })
      setLoading(false)
      if (additionalRes.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Lista salva com sucesso',
        }).then(() => navigate('/optionals'))
      } else {
        setLoading(false)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao salvar adicionais',
        })
      }
    } catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e && typeof e === 'string' ? e : 'Erro ao salvar adicionais',
      })
    }
  }

  const init = async () => {
    setLoading(true)
    await callAdditionals()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const cleanQueryLoading = (srcLd: string[]) => {
    setTimeout(() => {
      const newSearch = [...srcLd]
      newSearch.pop()
      setSearchLoading(newSearch)
      if (newSearch.length > 0) cleanQueryLoading(newSearch)
    }, 200)
  }

  useEffect(() => {
    filterWordsProducts()
    setSearchLoading([...searchLoading, '1'])
    cleanQueryLoading(searchLoading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`optional.list`)} "{additional?.name}"
                </span>
              </h3>
            </div>
            <div className='card-body border-bottom'>
              <div className='d-flex flex-row justify-content-end'>
                <Input
                  value={query}
                  inputAttr={{
                    type: 'search',
                    name: 'search',
                  }}
                  change={setQuery}
                  placeholder={i18n.t(`buttons.search`)}
                />
              </div>
              {searchLoading.length > 0 ? (
                <div className='d-flex flex-row justify-content-center align-items-center w-100'>
                  <ReactLoading type='spin' color='#D5D5D5' height={50} width={50} />
                </div>
              ) : (
                classificationWithProducts
                  .filter((cl) => cl.products.length > 0)
                  .map((classification) => (
                    <div className='d-flex flex-column mt-4' style={{width: '20rem'}}>
                      <div className='d-flex flex-row align-items-center'>
                        <Input
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          label={classification.name}
                          checked={verifyChecks(classification)}
                          value={verifyChecks(classification)}
                          change={() => {
                            checkAll(classification)
                          }}
                        />
                        {classification.extend ? (
                          <i
                            className='fa fa-chevron-down mt-4'
                            style={{cursor: 'pointer', marginLeft: '0.5rem'}}
                            onClick={() => changeExtend(classification)}
                          ></i>
                        ) : (
                          <i
                            className='fa fa-chevron-right mt-4'
                            style={{cursor: 'pointer', marginLeft: '0.5rem'}}
                            onClick={() => changeExtend(classification)}
                          ></i>
                        )}
                      </div>
                      {classification.products.map((product) => (
                        <div
                          className='d-flex flex-column'
                          style={
                            !classification.extend
                              ? {marginLeft: '1rem', visibility: 'hidden', position: 'absolute'}
                              : {marginLeft: '1rem'}
                          }
                        >
                          <Input
                            inputAttr={{
                              type: 'checkbox',
                            }}
                            label={`${product.code} - ${product.name}`}
                            checked={product.checked}
                            value={product.checked}
                            change={(value: boolean) => {
                              const newClassifications = [...classificationWithProducts]
                              newClassifications.forEach((cl) => {
                                cl.products.forEach((pd) => {
                                  if (pd.id === product.id) pd.checked = value
                                })
                              })
                              setClassificationWithProducts(newClassifications)

                              const newClassificationsAll = [...classificationWithProductsAll]
                              newClassificationsAll.forEach((cl) => {
                                cl.products.forEach((pd) => {
                                  if (pd.id === product.id) pd.checked = value
                                })
                              })
                              setClassificationWithProductsAll(newClassificationsAll)
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ))
              )}
            </div>
            <div className='d-flex justify-content-end gap-2 p-4'>
              <Button
                text={i18n.t('buttons.save')}
                color='primary'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => saveAdditionals()}
                btnClass='fw-bolder'
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const AssociarOpcionais: FC = () => {
  const params = useParams()
  const {type} = params

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: 'Opcionais', path: 'optionas', isActive: true},
        ]}
      >
        {`Criar ${type === 'itens-de-combo' ? 'itens de combo' : type}`}
      </PageTitle>
      <AssociarOpcionaisContent />
    </>
  )
}

export {AssociarOpcionais}
